// src/hooks/useReporteHoras.js
import { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import api from '../services/api';

export function useReporteHoras() {
    const [mesSeleccionado, setMesSeleccionado] = useState(format(new Date(), 'yyyy-MM'));
    const [estadisticas, setEstadisticas] = useState([]);
    const [loading, setLoading] = useState(false);

    const cargarReporte = useCallback(async () => {
        if (!mesSeleccionado) return;
        try {
            setLoading(true);
            const [year, month] = mesSeleccionado.split('-');
            const res = await api.get(`/fichajes/estadisticas?year=${year}&month=${month}`);
            setEstadisticas(res || []);
        } catch (err) {
            console.error('Error al cargar reporte de horas:', err);
            setEstadisticas([]);
        } finally {
            setLoading(false);
        }
    }, [mesSeleccionado]);

    useEffect(() => {
        cargarReporte();
    }, [cargarReporte]);

    return { mesSeleccionado, setMesSeleccionado, estadisticas, loading };
}